import { object, string } from "yup";
import { VALIDATIONS } from "../../../constants";

export const formLoginSchema = object({
  username: string().required(VALIDATIONS.required).email(VALIDATIONS.email),
  password: string().required(VALIDATIONS.required),
}).required();
